var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVehicleProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / ESS 32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-ESS-32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 5.000000)",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9999,0.0004 L-0.0001,1.0004 L-0.0001,21.0004 L0.9999,22.0004 L26.9999,22.0004 L27.9999,21.0004 L27.9999,1.0004 L26.9999,0.0004 L0.9999,0.0004 Z M14.0009,20.0004 L26.0009,20.0004 L26.0009,2.0004 L14.0009,2.0004 L14.0009,20.0004 Z M9.9999,20.0004 L11.9999,20.0004 L11.9999,2.0004 L9.9999,2.0004 L9.9999,20.0004 Z M5.9999,20.0004 L7.9999,20.0004 L7.9999,2.0004 L5.9999,2.0004 L5.9999,20.0004 Z M1.9999,20.0004 L3.9999,20.0004 L3.9999,2.0004 L1.9999,2.0004 L1.9999,20.0004 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "17 7 23 7 23 4 17 4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleProductIcon);
export default __webpack_public_path__ + "static/media/VehicleProductIcon.51c388a1f80e3789ddd81aca0adf784a.svg";
export { ForwardRef as ReactComponent };